/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState, Suspense } from 'react';
import { Formik, ErrorMessage } from 'formik';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  Autocomplete,
  Button,
  Box,
  CircularProgress,
  Grid,
  Card,
  CardMedia,
  // CardActionArea,
  CardContent,
  CardHeader,
  CardActions,
  TextField,
  // IconButton,
  Typography,
  FormHelperText,
  Stack,
  MenuItem,
  Avatar
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import ImageUploading from 'react-images-uploading';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { ValidateSignature } from '../../../assets/validation';
import SettingAction from '../../../store/actions/SettingAction';
import globalAction from '../../../store/actions/GlobalAction';
import Loader from '../../../utils/errorPages/Loader';

function SignatureSettingsEdit() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [imageLoader, setImageLoader] = React.useState(true);
  const [dataItem, setDataItem] = useState('');
  const [images, setImages] = React.useState([]);
  const { signItemData, isLoading } = useSelector((state) => state.setting);
  const { statusData, addressData } = useSelector((state) => state.global);

  const { REACT_APP_API_URL } = process.env;

  const { code } = useParams();
  const maxNumber = 1;
  const onChange = (imageList, addUpdateIndex) => {
    console.log(addUpdateIndex, 'addUpdateIndex');
    setImages(imageList);
    // if(imageList.length > 0) {
    // setImageError("");
    // }
  };
  const onErrorChange = (errors, files) => {
    console.log(files, 'files');
    if (errors) {
      // setImages([]);
    }
  };

  useEffect(() => {
    dispatch(globalAction.getClientStatus());
    dispatch(globalAction.getAddress());
    dispatch(SettingAction.getSignatureItem(code));
  }, [dispatch, code]);

  useEffect(() => {
    if (signItemData && signItemData !== undefined) {
      setDataItem(signItemData);
    }
  }, [signItemData]);

  useEffect(() => {
    setImageLoader(true);
    if (dataItem && dataItem !== undefined && dataItem !== '') {
      if (dataItem.signature && dataItem.signature !== undefined) {
        const arrValue = [];
        const arrObject = {
          path: dataItem.signature
        };
        arrValue.push(arrObject);
        setImages(arrValue);
      }
    }
    const timeoutId = setTimeout(() => {
      setImageLoader(false);
    }, 500);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [dataItem]);

  const getDirtyValues = (values, initialObject) => {
    const data = { ...values };
    const keyValues = Object.keys(data);

    const dirtyValues = keyValues.filter((keyValue) => data[keyValue] !== initialObject[keyValue]);

    keyValues.forEach((key) => {
      if (!dirtyValues.includes(key)) delete data[key];
    });
    return data;
  };
  const initialValues = {
    name: dataItem?.name ?? '',
    status: dataItem?.status ?? '',
    signature: [],
    addresses: dataItem?.addresses ?? []
  };

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper requestType">
      {isLoading ? <Loader /> : ''}
      <div className="pageTitleWrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="text" component={Link} to="/settings/signature">
            Signature Configuration
          </Typography>
          <Typography component="h2" variant="h2">
            / Edit
          </Typography>
        </Stack>
      </div>
      <Formik
        initialValues={initialValues}
        validationSchema={ValidateSignature}
        enableReinitialize
        onSubmit={(values, { setErrors, setSubmitting }) => {
          const updateValues = getDirtyValues(values, initialValues);
          const newValues = { ...updateValues };
          if (values.signature) {
            const newData = images.map((item) => item.file);
            if (newData.length > 0) {
              newValues.signature = newData;
            } else {
              delete newValues.signature;
            }
          }
          newValues.address_ids = JSON.stringify(
            (values.addresses ?? []).map((address) => address._id)
          );
          delete newValues.addresses;
          dispatch(
            SettingAction.updateSignature(code, newValues, setErrors, setSubmitting, navigate)
          );
        }}
      >
        {({
          errors,
          touched,
          values,
          handleBlur,
          handleChange,
          handleSubmit,
          handleReset,
          isSubmitting,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <Grid container spacing={2}>
              <Grid item md={12} lg={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardHeader title="Signature Details" />
                  <CardContent>
                    <Grid container columnSpacing={2} rowSpacing={2}>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="name"
                          name="name"
                          label="Name"
                          variant="outlined"
                          value={values.name}
                          margin="normal"
                          onChange={handleChange}
                          onBlur={(e) => {
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                            handleBlur(e);
                          }}
                          error={touched.name && Boolean(errors.name)}
                          helperText={touched.name && errors.name}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <Autocomplete
                          multiple
                          className="CurrencyField"
                          options={addressData ?? []}
                          value={values.addresses}
                          onChange={(e, newvalue) => {
                            setFieldValue('addresses', newvalue);
                          }}
                          getOptionLabel={(option) => option.address_type}
                          isOptionEqualToValue={(option, value) =>
                            option.address_type === value.address_type
                          }
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.address_type}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="addresses"
                              label="Office Addresses"
                              placeholder="Search Office Address"
                              variant="outlined"
                              margin="normal"
                              helperText="This signature becomes the active one for the selected addresses"
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mt: 1 }} columnSpacing={2} rowSpacing={1}>
                      <Grid item md={4} lg={4} xl={3}>
                        <ImageUploading
                          value={images}
                          onChange={onChange}
                          onError={onErrorChange}
                          maxFileSize={1048576}
                          maxNumber={maxNumber}
                          dataURLKey="data_url"
                          acceptType={['jpg', 'jpeg', 'png']}
                        >
                          {({
                            imageList,
                            onImageUpload,
                            onImageUpdate,
                            // onImageRemove,
                            // isDragging,
                            dragProps,
                            errors
                          }) => (
                            <div className="upload__image-wrapper">
                              {images && images.length > 0 ? (
                                imageList.map((image, index) => {
                                  return (
                                    <Card
                                      sx={{
                                        height: '100%',
                                        width: '100%',
                                        border: '1px dashed rgba(20,20,20,0.75)',
                                        minHeight: '100px',
                                        maxHeight: '100px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        cursor: 'pointer'
                                      }}
                                      key={index}
                                    >
                                      <Suspense fallback={<div>Loading...</div>}>
                                        {imageLoader ? (
                                          <CircularProgress size={20} />
                                        ) : (
                                          <CardMedia
                                            component="img"
                                            height="100"
                                            image={
                                              image.path
                                                ? `${REACT_APP_API_URL}/${image.path}`
                                                : image.data_url
                                            }
                                            alt="green iguana"
                                            onClick={() => onImageUpdate(index)}
                                          />
                                        )}
                                      </Suspense>
                                    </Card>
                                  );
                                })
                              ) : (
                                <Card
                                  sx={{
                                    height: '100%',
                                    width: '100%',
                                    border: '1px dashed rgba(20,20,20,0.75)',
                                    minHeight: '100px',
                                    maxHeight: '100px',
                                    // display: 'flex',
                                    // justifyContent: 'center',
                                    // alignItems: 'center',
                                    cursor: 'pointer'
                                  }}
                                  elevation={0}
                                >
                                  <CardContent sx={{ p: '20 !important', textAlign: 'center' }}>
                                    <Box
                                      sx={{ textAlign: 'center' }}
                                      onClick={onImageUpload}
                                      {...dragProps}
                                    >
                                      <Avatar sx={{ m: '0 auto', bgcolor: 'primary.main' }}>
                                        <FileUploadIcon />
                                      </Avatar>
                                      <FormHelperText
                                        sx={{ color: 'primary.main', textAlign: 'center' }}
                                      >
                                        Upload Image
                                      </FormHelperText>
                                    </Box>
                                  </CardContent>
                                </Card>
                              )}
                              {errors ? (
                                <FormHelperText error>
                                  {errors.acceptType && (
                                    <span>
                                      Please upload one of the supported files (PNG, JPEG, JPG)
                                    </span>
                                  )}
                                  {errors.maxFileSize && (
                                    <span>The uploaded image should not exceed 1 MB</span>
                                  )}
                                  {errors.resolution && (
                                    <span>Selected file is not matching desired resolution</span>
                                  )}
                                </FormHelperText>
                              ) : (
                                ''
                              )}
                              <FormHelperText error>
                                <ErrorMessage name="signature" component="span" />
                              </FormHelperText>
                              {/* <Stack
                                className="upload__helpText"
                                direction="row"
                                spacing={2}
                                justifyContent="space-between"
                                alignItems="center">
                                <Typography variant="body1" component="p">
                                  File Size: Max 5 Mb
                                </Typography>
                                <Typography variant="body1" component="p">
                                  File Resolution: above <b>600 x 600</b> or <b>1:1</b> aspect ratio
                                </Typography>
                                <Typography variant="body1" component="p">
                                  File Format: .jpeg .jpg .png .bmp\
                                </Typography>
                              </Stack> */}
                            </div>
                          )}
                        </ImageUploading>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mt: 1 }} columnSpacing={2} rowSpacing={2}>
                      <Grid item md={2} lg={2} xl={2}>
                        <TextField
                          id="status"
                          fullWidth
                          label="Status"
                          name="status"
                          margin="normal"
                          select
                          value={values.status}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.status && touched.status}
                          helperText={errors.status && touched.status && errors.status}
                          required={false}
                          InputLabelProps={{ required: true }}
                        >
                          {statusData &&
                            statusData.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {option.status}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={12} xl={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardActions sx={{ justifyContent: 'center', p: 3 }}>
                    <Button
                      type="submit"
                      className="save__btn"
                      variant="contained"
                      color="secondary"
                      // fullWidth
                      disabled={isSubmitting}
                      size="medium"
                    >
                      {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                    </Button>
                    <Button
                      type="button"
                      className="cancel__btn"
                      variant="contained"
                      // fullWidth
                      color="primary"
                      size="medium"
                      onClick={() => {
                        navigate('/settings/signature');
                      }}
                    >
                      Back
                    </Button>
                    <Button
                      type="button"
                      className="cancel__btn"
                      variant="contained"
                      // fullWidth
                      color="info"
                      size="medium"
                      onClick={() => {
                        handleReset();
                        setImages([]);
                      }}
                    >
                      Clear
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </Box>
  );
}
export default SignatureSettingsEdit;
